// FETCH ALL PROPERTIES FROM PRINTING_DC DETAILS
export const FETCH_PRINTING_DC_DETAILS_REQUEST_DK = 'FETCH_PRINTING_DC_DETAILS_REQUEST_DK';
export const FETCH_PRINTING_DC_DETAILS_SUCCESS_DK = 'FETCH_PRINTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_PRINTING_DC_DETAILS_FAILURE_DK = 'FETCH_PRINTING_DC_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM PRINTING_DC DETAILS
export const FETCH_PRINTING_DC_DETAILS_PROGRAM_REQUEST_DK = 'FETCH_PRINTING_DC_DETAILS_PROGRAM_REQUEST_DK';
export const FETCH_PRINTING_DC_DETAILS_PROGRAM_SUCCESS_DK = 'FETCH_PRINTING_DC_DETAILS_PROGRAM_SUCCESS_DK';
export const FETCH_PRINTING_DC_DETAILS_PROGRAM_FAILURE_DK = 'FETCH_PRINTING_DC_DETAILS_PROGRAM_FAILURE_DK';

// FETCH ALL PROPERTIES FROM PRINTING_DC DETAILS BY ID
export const FETCH_PRINTING_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_PRINTING_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_PRINTING_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_PRINTING_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_PRINTING_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_PRINTING_DC_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR PRINTING_DC DETAILS
export const CREATE_PRINTING_DC_DETAILS_REQUEST_DK = 'CREATE_PRINTING_DC_DETAILS_REQUEST_DK';
export const CREATE_PRINTING_DC_DETAILS_SUCCESS_DK = 'CREATE_PRINTING_DC_DETAILS_SUCCESS_DK';
export const CREATE_PRINTING_DC_DETAILS_FAILURE_DK = 'CREATE_PRINTING_DC_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_PRINTING_DC_DETAILS_DK = 'CREATE_USER_FORM_PRINTING_DC_DETAILS_DK';

// UPDATE PROPERTIES FOR PRINTING_DC DETAILS
export const UPDATE_PRINTING_DC_DETAILS_REQUEST_DK = 'UPDATE_PRINTING_DC_DETAILS_REQUEST_DK';
export const UPDATE_PRINTING_DC_DETAILS_SUCCESS_DK = 'UPDATE_PRINTING_DC_DETAILS_SUCCESS_DK';
export const UPDATE_PRINTING_DC_DETAILS_FAILURE_DK = 'UPDATE_PRINTING_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE PRINTING_DC_DETAILS
export const FETCH_SINGLE_PRINTING_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_PRINTING_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_PRINTING_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_PRINTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_PRINTING_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_PRINTING_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR PRINTING_DC DETAILS
export const DELETE_PRINTING_DC_DETAILS_REQUEST_DK = 'DELETE_PRINTING_DC_DETAILS_REQUEST_DK';
export const DELETE_PRINTING_DC_DETAILS_SUCCESS_DK = 'DELETE_PRINTING_DC_DETAILS_SUCCESS_DK';
export const DELETE_PRINTING_DC_DETAILS_FAILURE_DK = 'DELETE_PRINTING_DC_DETAILS_FAILURE_DK';

// USERFORM RESET

export const PRINTING_DC_DETAILS_USERFORM_RESET_DK = 'PRINTING_DC_DETAILS_USERFORM_RESET_DK';

//DCNO
export const FETCH_PRINTING_DC_DETAILS_DC_NO_REQUEST_DK_DK = 'FETCH_PRINTING_DC_DETAILS_DC_NO_REQUEST_DK_DK';
export const FETCH_PRINTING_DC_DETAILS_DC_NO_SUCCESS_DK_DK = 'FETCH_PRINTING_DC_DETAILS_DC_NO_SUCCESS_DK_DK';
export const FETCH_PRINTING_DC_DETAILS_DC_NO_FAILURE_DK_DK = 'FETCH_PRINTING_DC_DETAILS_DC_NO_FAILURE_DK_DK';

//GRN NO
export const FETCH_GRN_NO_BY_PRINTING_DC_NO_REQUEST_DK_DK = 'FETCH_GRN_NO_BY_PRINTING_DC_NO_REQUEST_DK_DK';
export const FETCH_GRN_NO_BY_PRINTING_DC_NO_SUCCESS_DK_DK = 'FETCH_GRN_NO_BY_PRINTING_DC_NO_SUCCESS_DK_DK';
export const FETCH_GRN_NO_BY_PRINTING_DC_NO_FAILURE_DK_DK = 'FETCH_GRN_NO_BY_PRINTING_DC_NO_FAILURE_DK_DK';

export const PRINTING_CLOSE_BTN_POST_REQUEST = 'PRINTING_CLOSE_BTN_POST_REQUEST'
export const PRINTING_CLOSE_BTN_POST_SUCCESS = 'PRINTING_CLOSE_BTN_POST_SUCCESS'
export const PRINTING_CLOSE_BTN_POST_FALIURE = 'PRINTING_CLOSE_BTN_POST_FALIURE'



export const PRINTING_CHECK_ALL_UPDATE_REQUEST = 'PRINTING_CHECK_ALL_UPDATE_REQUEST'
export const PRINTING_CHECK_ALL_UPDATE_SUCCESS = 'PRINTING_CHECK_ALL_UPDATE_SUCCESS'
export const PRINTING_CHECK_ALL_UPDATE_FALIURE = 'PRINTING_CHECK_ALL_UPDATE_FALIURE'